import { render, staticRenderFns } from "./TransactSql.vue?vue&type=template&id=56003051"
import script from "./TransactSql.vue?vue&type=script&lang=js"
export * from "./TransactSql.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports